export default "__VITE_ASSET__D3xHHeb2__"